import React, { createContext, useContext, useState } from 'react';
import { loginService } from '../services/authService';

interface AuthContextType {
  isAuthenticated: boolean;
  login: (username: string, password: string) => Promise<void>;
  logout: () => void;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const login = async (username: string, password: string) => {
    const data = await loginService(username, password);

    if (data.isValid === false) {
      throw new Error(data.message || 'Invalid username or password');
    }

    if (data.isValid && data.isPasswordResetRequired) {
      // handle password reset case
      alert('Password reset required. Redirecting...');
      // you could navigate to a reset page here if needed
      return;
    }

    if (data.token) {
      // Store tokens and user info
      localStorage.setItem('token', data.token);
      localStorage.setItem('refreshToken', data.refreshToken || '');
      localStorage.setItem('user', JSON.stringify(data.user));
      localStorage.setItem('userRoles', JSON.stringify(data.roles));
      setIsAuthenticated(true);
    }
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('user');
    setIsAuthenticated(false);
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) throw new Error('useAuth must be used within an AuthProvider');
  return context;
};
